/* eslint-disable no-param-reassign */
const SCROLL_OFFSET = 180;

/**
 * Инициализирует плавный скролл для якорных ссылок с классом `.click-smooth`.
 *
 * При клике на такую ссылку страница плавно прокручивается к целевому элементу,
 * учитывая заданный отступ сверху (SCROLL_OFFSET).
 *
 * @function initSmoothScrollLinks
 */
function initSmoothScrollLinks() {
  document.querySelectorAll(".click-smooth").forEach((link) => {
    const targetId = link.getAttribute("href");
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const offset = SCROLL_OFFSET;
        const elementPosition =
          targetElement.getBoundingClientRect().top + window.scrollY;
        const adjustedPosition = elementPosition - offset;

        window.scrollTo({
          top: adjustedPosition,
          behavior: "smooth",
        });
      });
    } else {
      link.style.display = "none";
    }
  });
}

export default initSmoothScrollLinks;
